import React from 'react';

export const progressCount = (
    progress: React.RefObject<HTMLDivElement | null>,
    count: React.RefObject<HTMLDivElement | null>
) => {
    let width = 0;

    const frame = () => {
        if (width === 95) {
            clearInterval(interval);
        } else {
            width++;
            if (progress.current !== null && count.current !== null) {
                progress.current.style.width = width + '%';
                count.current.textContent = width + '%';
            }
        }
    };

    const interval = setInterval(frame, 60);
};
